module.exports = __webpack_public_path__ + "static/img/logo.f5b1ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/ssipc/logo.png
// module id = NnCv
// module chunks = 23